// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-404-demolition-js": () => import("./../../../src/templates/404-demolition.js" /* webpackChunkName: "component---src-templates-404-demolition-js" */),
  "component---src-templates-demolition-index-js": () => import("./../../../src/templates/demolition-index.js" /* webpackChunkName: "component---src-templates-demolition-index-js" */),
  "component---src-templates-pro-registration-js": () => import("./../../../src/templates/pro-registration.js" /* webpackChunkName: "component---src-templates-pro-registration-js" */)
}

